import ContentPrice from '../contentprice/ContentPrice';
import Badge from '@core/components/badge/Badge';
import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';
import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';

import { useMutation } from 'react-query';
import { JobQualificationWaitingList, CourseWaitingList } from 'services/core';

import { Star1, ArrowRight2 } from 'iconsax-react';
import PremiumBadge from 'assets/icons/premium-badge.svg';

import classes from './ExploreContentCard.module.scss';


const ContentTypeBadge = ({ type }) => {
	return (
		<div
			className={classes['content-badge-wrapper']}
			style={{ backgroundColor: type === 'course' ? '#4ECDC4' : '#BB3A90' }}>
			{type === 'course' ? 'Job Qualification' : 'Course'}
		</div>
	);
};

const ExploreContentCard = ({ content, toast, loginNoticeShowModal, isFeatured = false }) => {
	const isNotComingSoon = content.status !== 'coming_soon';

	const joinWaitingListService =
		content.type === 'lecture' ? CourseWaitingList.POST : JobQualificationWaitingList.POST;

	const { mutate: callAddToWaitingList, isLoading: addToWaitingListLoading } = useMutation(
		joinWaitingListService,
		{
			onSuccess: (data) => {
				toast(<div className="d-flex gap-3">{data.data?.message}</div>);
			},
			onError: (error) => {
				if (error.response.status === 401) {
					loginNoticeShowModal();
				} else {
					toast(error.response.data.data, 'Alert');
				}
			}
		}
	);

	const handleJoinWaitingList = (e) => {
		e.preventDefault();
		callAddToWaitingList(content.id);
	};

	return (
		<LinkButton
			kind="simple"
			to={`/${content.type === 'lecture' ? 'courses' : 'job-qualifications'}/${content.id}/${content.slug
				}`}>
			<div className={`${classes['content-card-detail']} row gap-3 gap-lg-0 m-0`}>
				<div className="col-12 col-xl-4 col-lg-5 p-0 position-relative">
					<img src={content.image} alt={content.title} />
					{!isFeatured && (
						<>
							{content.is_coming_soon && (
								<div className={classes['comingsoon-badge']}>
									Coming Soon
								</div>
							)}
							{content.is_new && (
								<div className={classes['new-badge']}>
									New
								</div>
							)}
						</>
					)}
				</div>
				<div className="col-12 col-xl-8 col-lg-7 d-flex flex-column gap-3 justify-content-between py-0 py-lg-2">
					<div
						className={`${classes['content-card-detail-title']} d-flex flex-row align-items-center justify-content-between`}>
						<div className='d-flex flex-column gap-1 w-100'>
							<div className="d-flex flex-row justify-content-between align-items-center gap-3 w-100">
								<h5>{content.title}</h5>
								<Badge status={content.status} />
							</div>

							{isNotComingSoon && (
								<div className="d-flex flex-row flex-wrap align-items-center gap-3">
									{!!content.rate_average && (
										<>
											<Star1 color="#FAA61A" size={14} className={`${classes['filled-star']}`} />
											<h6>{content.rate_average}</h6>
										</>
									)}
									{content?.is_free ?
										(
											<span className={classes['free-badge']}>Free</span>
										) : (
											<PremiumBadge />
										)}
									{/* <span className={classes['dot']} /> */}
									{/* <p>{content.participants_count} participants</p> */}
								</div>
							)}
						</div>
						{/* <div className="d-none d-lg-block">
							<ContentTypeBadge type={content.type} />
						</div> */}
					</div>
					<p className={`${classes['content-card-detail-description']}`}>
						{content.short_introduction}
					</p>
					{/* <div className="d-block d-lg-none">
						<ContentTypeBadge type={content.type} />
					</div> */}
					<div
						className={`${classes['content-card-detail-actions']} d-flex flex-row justify-content-between align-items-center`}>
						{/* {isNotComingSoon ? <ContentPrice {...content} /> : <Badge status={content.status} />} */}
						<span>
							<ProficiencyBadge proficiency={content?.proficiency} />
						</span>
						{isNotComingSoon ? (
							<LinkButton
								kind="simple"
								to={`/${content.type === 'lecture' ? 'courses' : 'job-qualifications'}/${content.id
									}/${content.slug}`}>
								Details <ArrowRight2 color="#bb3a90" />
							</LinkButton>
						) : (
							<ActionButton onClick={handleJoinWaitingList} kind="secondary">
								Join waiting list
							</ActionButton>
						)}
					</div>
				</div>
			</div>
		</LinkButton>
	);
};

export default ExploreContentCard;
